import { createBlockerStore } from '../../createBlockerStore';

export const {
  Provider: NavigationBlockingProvider,
  useStore: useNavigationBlockers,
} = createBlockerStore();
